const LeadsIndex = () => import("@/views/channel/leads/index.vue");
const LeadsView = () => import("@/views/channel/leads/view.vue");
const CampaignsIndex = () => import("@/views/channel/campaigns/index.vue");
const ContentManagementIndex = () =>
    import("@/views/channel/contentManagement/index.vue");
const EditBlogs = () =>
    import("@/views/channel/contentManagement/editBlogs.vue");
const CreateBlogs = () =>
    import("@/views/channel/contentManagement/createBlogs.vue");
const CRMIndex = () => import("@/views/channel/crm/index.vue");
const CRMView = () => import("@/views/channel/crm/view.vue");
const TicketManagementIndex = () => import("@/views/channel/ticketManagement/index.vue");
import TicketManagementView from "@/views/channel/ticketManagement/view.vue";

export default {
    path: "/home",
    meta: { label: "Channel" },
    component: {
        render(h) {
            return h("router-view");
        },
    },
    children: [
        // ---------------- LEADS ----------------
        {
            path: "/channels/leads",
            meta: { label: "Leads" },
            component: {
                render(h) {
                    return h("router-view");
                },
            },
            children: [
                {
                    path: "",
                    meta: { requiresAuth: true },
                    component: LeadsIndex,
                },
                {
                    path: "view/:id",
                    name: "leads-view",
                    meta: { requiresAuth: true },
                    component: LeadsView,
                },
            ],
        },

        // ---------------- CAMPAIGNS ----------------
        {
            path: "/channels/campaigns",
            name: "channels-campaigns",
            meta: {
                label: "Campaigns",
                requiresAuth: true,
            },
            component: CampaignsIndex,
        },
        // ---------------- CONTENT MANAGEMENT ----------------
        {
            path: "/channels/contentManagement",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(h) {
                    return h("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "content-management",
                    meta: {
                        label: "Content Management",
                    },
                    component: ContentManagementIndex,
                },
                {
                    path: "create",
                    name: "content-management-create",
                    component: CreateBlogs,
                    meta: {
                        label: "Create Blog",
                    },
                },
                {
                    path: "edit/:id",
                    name: "content-management-edit",
                    component: EditBlogs,
                    meta: {
                        label: "Edit Blog",
                    },
                },
            ],
        },
        // ---------------- CRM ----------------
        {
            path: "/channels/crm",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(h) {
                    return h("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "CRM",
                    meta: { label: "CRM" },
                    component: CRMIndex,
                },
                {
                    path: "view/:id",
                    name: "crm-view",
                    meta: { label: "View CRM" },
                    component: CRMView,
                },
            ],
        },
        // ---------------- Ticket Management ----------------
        {
            path: "/channels/ticketManagement",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(h) {
                    return h("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "ticketManagement",
                    meta: { label: "Ticket Management" },
                    component: TicketManagementIndex,
                },
                {
                    path: "view/:id",
                    name: "ticketManagement-view",
                    meta: { label: "View Support Ticket" },
                    component: TicketManagementView,
                },
            ],
        },
    ],
};